"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.separateByThreeDigit = exports.toOrdinalWords = exports.toOrdinal = exports.toWords = exports.toTruncated = exports.toCurrencyTruncated = exports.toCurrency = exports.toFactor = exports.toPercentage = exports.toSignificant = void 0;
var numberToWords = __importStar(require("number-to-words"));
var round_to_1 = __importDefault(require("round-to"));
var numeralService_1 = require("../services/numeralService");
var support_1 = require("../support");
/**
 * Returns a number formatted to x significant digits or decimal places.
 */
function toSignificant(value, significance) {
    if (value === void 0) { value = 0; }
    if (significance === void 0) { significance = 2; }
    var floatValue;
    try {
        floatValue = parseFloat(value.toString()) || 0;
    }
    catch (reason) {
        floatValue = 0;
    }
    if (floatValue === 0)
        return '0';
    else if (support_1.isTiny(floatValue)) {
        // Numeral will return NaN for any number less than e-6
        // As we tend to present formatted numbers rounded to 2/3 decimal places,
        // the presentational significance is therefore capped to a maximum of
        // 6 decimal places, else we present 0 (no more NaNs).
        if ((floatValue > 0 && floatValue < 0.000001) ||
            (floatValue < 0 && floatValue > -0.000001))
            return '0';
        // Note: toPrecision() doesn't behave rounding 5 up e.g. 0.00000175 becomes
        // 0.0000017 instead of 0.0000018. We need to find a solution for this to be
        // 100% accurate, but the value is tiny enough not to be a huge concern.
        return significance > 0
            ? floatValue.toPrecision(significance)
            : floatValue.toString();
    }
    return round_to_1["default"](value, significance).toString();
}
exports.toSignificant = toSignificant;
/**
 * Convert input to a readable percentage value.
 */
function toPercentage(value, significance) {
    if (significance === void 0) { significance = 0; }
    if (value === 0)
        return '0%';
    if (support_1.isTiny(value * 100))
        return numeralService_1.format(toSignificant(value, significance), "0." + support_1.buildZeroString(significance) + "[" + support_1.buildZeroString(10) + "]%");
    var significantValue = toSignificant(value * 100, significance);
    return numeralService_1.format(Number(significantValue) / 100, "0,0." + support_1.buildZeroString(significance) + "%");
}
exports.toPercentage = toPercentage;
/**
 * Convert input to a factor e.g. 12.5x. Removes trailing zeros.
 */
function toFactor(value, significance) {
    if (significance === void 0) { significance = 2; }
    if (value === 0)
        return '0x';
    return Number(toSignificant(value, significance)).toString() + 'x';
}
exports.toFactor = toFactor;
/**
 * Format a number with currency symbol and commas (or locale equivalent).
 */
function toCurrency(value, significance, iso) {
    if (significance === void 0) { significance = 0; }
    if (iso === void 0) { iso = 'USD'; }
    return numeralService_1.withCurrency(iso, function () {
        var significantValue = toSignificant(value, significance);
        if (significantValue === '0')
            return numeralService_1.format(significantValue, '$0').trim();
        else if (support_1.isTiny(Number(significantValue)))
            return numeralService_1.format(significantValue, "$0,0." + support_1.buildZeroString(significance) + "[" + support_1.buildZeroString(10) + "]").trim();
        return numeralService_1.format(significantValue, "$0,0." + support_1.buildZeroString(significance)).trim();
    });
}
exports.toCurrency = toCurrency;
/**
 * Format a number with currency symbol and unit suffix (e.g. m for millions, b
 * for billions, etc).
 */
function toCurrencyTruncated(value, significance, iso) {
    if (significance === void 0) { significance = 2; }
    if (iso === void 0) { iso = 'USD'; }
    return numeralService_1.withCurrency(iso, function () {
        var significantValue = toSignificant(value, significance);
        if (significantValue === '0')
            return numeralService_1.format(significantValue, '$0').trim();
        else if (support_1.isTiny(Number(significantValue))) {
            return numeralService_1.format(significantValue, "$0." + support_1.buildZeroString(significance) + "[" + support_1.buildZeroString(10) + "]").trim();
        }
        return numeralService_1.format(significantValue, "$0." + support_1.buildZeroString(significance) + "a").trim();
    });
}
exports.toCurrencyTruncated = toCurrencyTruncated;
/**
 * Format a number with unit suffix (e.g. m for millions, b
 * for billions, etc).
 */
function toTruncated(value, significance) {
    if (significance === void 0) { significance = 2; }
    var significantValue = toSignificant(value, significance);
    if (Number(significantValue) === 0)
        return numeralService_1.format(significantValue, '0');
    else if (support_1.isTiny(Number(significantValue)))
        return numeralService_1.format(significantValue, "0." + support_1.buildZeroString(significance) + "[" + support_1.buildZeroString(10) + "]");
    return numeralService_1.format(significantValue, "0." + support_1.buildZeroString(significance) + "a");
}
exports.toTruncated = toTruncated;
function toWords(value, limit) {
    return !limit || value < limit
        ? numberToWords.toWords(value)
        : value.toString();
}
exports.toWords = toWords;
function toOrdinal(value) {
    return numberToWords.toOrdinal(value);
}
exports.toOrdinal = toOrdinal;
function toOrdinalWords(value) {
    return numberToWords.toWordsOrdinal(value);
}
exports.toOrdinalWords = toOrdinalWords;
/**
 * Format a number by three digits
 *
 * @param value The number to be formatted
 * @param significance
 */
function separateByThreeDigit(value, significance) {
    if (significance === void 0) { significance = 0; }
    var repeat = function (s, n) {
        var result = '';
        for (var i = 0; i < n; i++)
            result += s;
        return result;
    };
    var significanceFormatting = significance > 0 ? '.' + repeat('0', significance) : '';
    return numeralService_1.format(value, "0,0" + significanceFormatting);
}
exports.separateByThreeDigit = separateByThreeDigit;
